import Vue from 'vue';

import CheckboxVue from './Checkbox.vue';

export default function checkboxComponent(_Vue: typeof Vue) {
  _Vue.component('AppCheckbox', CheckboxVue);
}
